import * as React from "react";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import { Divider, IconButton } from "@mui/material";
import SoftBox from "components/SoftBox";
import { useSelector } from "react-redux";
import SoftTypography from "components/SoftTypography";
import CloseIcon from '@mui/icons-material/Close';

export default function BasicModal({
	children,
	show,
	unShow,
	width,
	height,
	overflowY,
	title,
	footer,
	isremoveCrossIcon = true,
}) {
	const userTheme = useSelector((state) => state.commonSlice.theme);

	const backdropColor =
		userTheme === "dark"
			? "rgba(0, 0, 0, 0.75)"
			: "rgba(0, 0, 0, 0.5)";

	const modalStyle = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: "100%",
		maxWidth: width || 500,
		maxHeight: "85vh",
		height: "auto",
		bgcolor: userTheme === "dark" ? "#2c2c2c" : "#fff",
		boxShadow: 24,
		borderRadius: 2,
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
		color: userTheme === "dark" ? "#fff" : "#000",
	};

	const contentStyle = {
		flex: 1,
		overflowY: overflowY ? "scroll" : "auto",
	};

	return (
		<Modal
			open={show}
			onClose={() => unShow(false)}
			aria-labelledby="modal-title"
			aria-describedby="modal-description"
			sx={{
				backdropFilter: "blur(5px)",
				backgroundColor: backdropColor,
				zIndex: 9999,
			}}
		>
			<SoftBox sx={modalStyle}>
				{/* Header */}
				{isremoveCrossIcon && (title || true) && (
					<SoftBox
						display="flex"
						alignItems="center"
						justifyContent="space-between"
						p={2}
						borderBottom="1px solid #ddd"
					>
						<SoftTypography variant="h6" id="modal-title">
							{title}
						</SoftTypography>
						<IconButton onClick={() => unShow(false)} size="small">
							<CloseIcon />
						</IconButton>
					</SoftBox>
				)}

				{/* Body */}
				<SoftBox id="modal-description" sx={{
					...contentStyle, p: 2,
				}}>
					{children}
				</SoftBox>

				{/* Footer */}
				{footer && (
					<>
						<Divider />
						<SoftBox
							display="flex"
							justifyContent="flex-end"
							alignItems="center"
							p={2}
							gap={1}
							borderTop="1px solid #ddd"
						>
							{footer}
						</SoftBox>
					</>
				)}
			</SoftBox>
		</Modal>
	);
}

BasicModal.propTypes = {
	children: PropTypes.node.isRequired,
	show: PropTypes.bool.isRequired,
	unShow: PropTypes.func.isRequired,
	width: PropTypes.string,
	height: PropTypes.string,
	overflowY: PropTypes.bool,
	title: PropTypes.node,
	footer: PropTypes.node,
};
